<div class="row">
    <div class="col-sm-12">
      <app-nav-home-student [linkId]="2" [learner]='learner'></app-nav-home-student>
    </div>
</div>
<div class="row">
  <div class="col-sm-3">
    <app-side-bar-guardian-home
    [guardian]="guardian"
    [target_student_user_id]="0">
  </app-side-bar-guardian-home>
      </div>
    <div class="col-sm-9">

        <div *ngIf="doneQuizEnvelops">

            <div class="table-responsive" *ngIf="!loadingEnvelops && doneQuizEnvelops.length>0">
               <table datatable  [dtOptions]="dtOptions"  class="row-border hover table table-striped display compact" >
                           <thead>
                           <tr>
                              <th>Id</th>
                              <th>Date Created</th>
                              <th>Subject Name</th>
                              <th>Questions</th>
                              <th class="text-end">Score (%)</th>
                           </tr>
                           </thead>

                           <tbody>

                               <tr *ngFor="let quizEnvelop of doneQuizEnvelops">
                               <td>{{quizEnvelop.server_quiz_envelop_id}}</td>
                               <td>{{quizEnvelop.datecreated}}</td>
                               <td>{{quizEnvelop.subjectName}}</td>
                               <td><a [routerLink]="['/student/quiz/review',learner.server_user_id,quizEnvelop.server_quiz_envelop_id]">View ({{quizEnvelop.question_count}})</a></td>
                               <td class="text-end">{{quizEnvelop.score}}</td>
                               </tr>
                           </tbody>

               </table>
               </div>
               <div *ngIf="doneQuizEnvelops.length == 0  && !loadingEnvelops" class="alert alert-info text-center">  No Pending Quiz </div>
              </div>

               <app-spinner *ngIf="loadingEnvelops"> </app-spinner>
               <fieldset class="text-center mt-4" *ngIf="learner.server_student_id!=0">
               <hr/>
               <a [routerLink]="['/student/show',learner.server_student_user_id]" class="btn btn-primary me-2" ><i class="fa fa-plus"></i> Pick Another Quiz for {{subscription.name}}</a>
               <a [routerLink]="['/area/quiz/modify',server_student_user_id]" class='btn btn-outline-primary me-2'> Change Quiz Topics </a>
               <a  *ngIf="authService.isGranted('ROLE_GUARDIAN')" [routerLink]="['/guardian/show',learner.server_guardian_user_id]"  class="btn btn-primary"><i class="fa fa-close"></i> Close</a>
               </fieldset>


    </div>
</div>

<div class="row">
  <div class="col-sm-12">
    <app-spinner *ngIf="!maskedGift"></app-spinner>
    <app-student-gift-area *ngIf="(maskedGift && learner)" [maskedGift]="maskedGift" [learner]="learner"></app-student-gift-area>
</div>
    </div>

